export const toQueryParams = (obj, prefix = '') => {
  return Object.keys(obj)
    .map(key => {
      const value = obj[key]
      const prefixedKey = prefix ? `${prefix}[${key}]` : key

      if (Array.isArray(value)) {
        return value
          .map(
            val =>
              `${encodeURIComponent(prefixedKey)}=${encodeURIComponent(val)}`,
          )
          .join('&')
      } else if (typeof value === 'object' && value !== null) {
        return toQueryParams(value, prefixedKey)
      } else {
        return `${encodeURIComponent(prefixedKey)}=${encodeURIComponent(value)}`
      }
    })
    .join('&')
}

// every stored file reference already carries ?bucket=, so a second ? would make
// the token part of the bucket value
export const authSeparator = url => (String(url).includes('?') ? '&' : '?')

export const formatUrlForAuthImg = url => {
  if (!url) return
  const auth = localStorage.getItem('token')
  if (!auth) return
  return `${url}${authSeparator(url)}authorization=${auth}`
}

export function excludeFieldsFormatter({ field, useExclude = false } = {}) {
  if (!field) return undefined

  const isArray = Array.isArray(field)
  const arr = isArray ? field : [field]
  if (!arr.length) return undefined
  
  if (!useExclude) return arr
  if (arr.length === 1) return { $ne: arr[0] }
  return { $nin: arr }
}
